export enum AnalysisRequestStatus {
  DONE = "DONE",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  REFUSED = "REFUSED",
}
